export default "__VITE_ASSET__677e5a10__"